export const update = {
  form: {
    code: '納入先 CD',
    name: '顧客名',
    shortName: '顧客名(省略)',
    method: '洗浄プログラム',
    update: '保存',
    requireCode: '顧客コードを入力してください',
    requireName: '顧客名を入力してください',
    requireShortName: '顧客名(省略)を入力してください',
    requireMethod: '洗浄プログラムを入力してください',
    cancel: 'キャンセル',
    invalidLetters: '文字のみ入力できます。',
    invalidNumbers: '数字のみ入力できます。',
  },
  pageHeader: {
    title: '顧客リスト　顧客情報編集画面',
    back: '戻る',
  },
}
